import React from 'react';
import { useSelector } from "react-redux";

import { styled, useTheme, Popover, Typography } from '@mui/material';


const PREFIX = 'Tooltip';

const classes = {
    popover: `${PREFIX}-popover`,
    paper: `${PREFIX}-paper`
};

const StyledPopover = styled(Popover)((
	{
		tooltipcontent,
		theme
	}
) => ({
    [`&.${classes.popover}`]: {
        pointerEvents: 'none',
    },
    [`& .${classes.paper}`]: {
        ...tooltipcontent.paper,
        padding: theme.spacing(1),
        maxWidth: "300px"
    },
}));


export default function Tooltip() {

    // App State
    const tooltipContent = useSelector(state => state.app.tooltipContent);


    const anchorOrigin = tooltipContent.configuration?.element?.anchorOrigin !== undefined ? tooltipContent.configuration.element.anchorOrigin : {
        vertical: 'center',
        horizontal: 'center'
    };
    const transformOrigin = tooltipContent.configuration?.element?.transformOrigin !== undefined ? tooltipContent.configuration.element.transformOrigin : {
        vertical: 'top',
        horizontal: 'left'
    };

    return (
        <StyledPopover
            id="mouse-over-popover"
			tooltipcontent={tooltipContent}
            className={classes.popover}
            classes={{ paper: classes.paper }}
            open={tooltipContent.open}
            anchorReference="anchorEl"
            anchorEl={tooltipContent.anchorEl}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            disableRestoreFocus
        >
            <Typography variant="caption" dangerouslySetInnerHTML={{__html: tooltipContent.message}}></Typography>
        </StyledPopover>
    );
}
